"use strict";
exports.__esModule = true;
var Row = /** @class */ (function () {
    function Row(_a) {
        var column = _a.column, value = _a.value, breakdown = _a.breakdown;
        var _this = this;
        this.toJSON = function () { return ({
            column: _this.column,
            value: _this.value,
            breakdown: _this.breakdown
        }); };
        this.column = column;
        this.value = value;
        this.breakdown = breakdown;
    }
    Row.fromJSON = function (json) {
        var _a = Object.assign({}, json), column = _a.column, value = _a.value, breakdown = _a.breakdown;
        if (typeof column !== 'string')
            throw new Error('.column must be a string');
        if (typeof value !== 'number' && value !== undefined && value !== null)
            throw new Error('.value must be a number');
        if (!Array.isArray(breakdown) && breakdown !== undefined && breakdown !== null)
            throw new Error('.breakdown must be an array');
        return new Row({
            column: column,
            value: value,
            breakdown: breakdown
        });
    };
    return Row;
}());
exports["default"] = Row;
